import { Flex, Stack } from "@storyofams/react-ui";
import { SystemProps } from "@storyofams/react-ui";
import { DynamicSections } from "..";

type ColumnsProps = {
  first?: boolean;
  content: any;
  parentComponent?: string;
} & SystemProps;

export const Columns = ({ content }: ColumnsProps) => {
  return (
    <Flex
      flexDirection={["column", "row"]}
      width="100%"
      overflow={"hidden"}
      border={content.isBorderEnabled ? "1px solid grey200" : "none"}
      borderRadius={content.isBorderEnabled ? "lg" : "none"}
      maxWidth={content?.small ? "880px" : "none"}
      mb={0}
    >
      <Stack
        width={["100%", content.ratio || "50%"]}
        p={[
          (content.left_padding_mobile || 0) + "px",
          (content?.left_padding || 0) + "px",
        ]}
        flexDirection="column"
        space={[3, 6]}
        backgroundColor={
          content?.isLeftBgEnabled ? content?.leftBg?.color : "none"
        }
        mb={0}
      >
        <DynamicSections
          sections={content?.left_column}
          parentComponent="columns"
        />
      </Stack>
      <Stack
        order={[content?.right_column[0]?.component === "image" && -1, 1]}
        flex={1}
        width={["100%", "50%"]}
        backgroundColor={
          content?.isRightBgEnabled ? content?.rightBg?.color : "none"
        }
        flexDirection="column"
        space={[3, 6]}
      >
        <DynamicSections
          sections={content?.right_column}
          parentComponent="columns"
        />
      </Stack>
    </Flex>
  );
};
